'use client';
import styled from 'styled-components';

export const StyledCountdownContainer = styled.div`
  min-height: 50px;
`;
